import layoutHeaderAside from "@/layout/header-aside";

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require("@/libs/util.import." + process.env.NODE_ENV);

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: "/",
    redirect: { name: "index" },
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: "index",
        name: "index",
        affix: true,
        meta:{
          cache:true
        },
        component: _import("Dashbord/Dashbord"),
      },

      // 客户
      {
        path: "Customer",
        name: "Customer",
        component: _import("Customer/Customer"),
        meta: {
          cache: true
        },
      },
      {
        path: "CustomerManagement",
        name: "CustomerManagement",
        component: _import("Customer/CustomerManagement"),
        meta: {
          cache: true
        },
      },
      // 客户
      {
        path: "CustomerSalesInfo",
        name: "CustomerSalesInfo",
        component: _import("Customer/Customer"),
        meta: {
          cache: true
        },
      },
      {
        path: "CustomerDet",
        name: "CustomerDet",
        meta: {
          hidden: true,
          cache: true
        },
        component: _import("Customer/CustomerDet"),
      },
      // 订单
      {
        path: "OrderStatus",
        name: "OrderStatus",
        component: _import("Order/Order"),
        meta: {
          cache: true

        },
      },
      // 订单平均交货时间
      {
        path: "OrderAverageDeliveryTime",
        name: "OrderAverageDeliveryTime",
        meta: {
          hidden: true,
          cache:true
        },
        component: _import("Order/OrderAverageDeliveryTime"),
      },
      // 订单货期概览
      {
        path: "OrderDeliveryTimeOverview",
        name: "OrderDeliveryTimeOverview",
        meta: {
          cache: true
        },
        component: _import("Order/OrderDeliveryTimeOverview"),
      },
      // 订单货期详情
      {
        path: "OrderDeliveryTimeDetail",
        name: "OrderDeliveryTimeDetail",
        meta: {
          cache: true
        },
        component: _import("Order/OrderDeliveryTimeDetail"),
      },
      {
        path: "OrderContract",
        name: "OrderContract",
        meta: {
          hidden: true,
          cache:true
        },
        component: _import("Order/OrderContract"),
      },
      {
        path: "OrderDet",
        name: "OrderDet",
        meta: {
          hidden: true,
          cache: true
        },
        component: _import("Order/OrderDet"),
      },

      // 报表
      {
        path: "Report",//和下面的重复了，有一个是移动app界面，所以name是？
        name: "Report",
        meta: {
          cache: true
        },
        component: _import("Report/Report"),
      },
      {
        path: "ReportDet",
        name: "ReportDet",
        meta: {
          cache:true
        },
        component: _import("Report/ReportDet"),
      },
      // {
      //   path: "Report",
      //   name: "Report",
      //   meta: {
      //   },
      //   component: _import("Report/ReportOne"),
      // },
      {
        path: "ReportOne",
        name: "ReportOne",
        meta: {
          cache: true
        },
        component: _import("Report/ReportOne"),
      },
      {
        path: "ReportTwo",
        name: "ReportTwo",
        meta: {
          cache: true
        },
        component: _import("Report/ReportTwo"),
      },
      {
        path: "ReportThree",
        name: "ReportThree",
        meta: {
          cache:true
        },
        component: _import("Report/ReportThree"),
      },
      {
        path: "ReportFour",
        name: "ReportFour",
        meta: {
          cache: true
        },
        component: _import("Report/ReportFour"),
      },
      {
        path: "ReportFive",
        name: "ReportFive",
        meta: {
          cache: true

        },
        component: _import("Report/ReportFive"),
      },
      {
        path: "ExportDeliveryReport",
        name: "ExportDeliveryReport",
        meta: {
          cache: true,
          pass:true,

        },
        component: _import("Report/ExportDeliveryReport/index"),
      },
      {
        path: "ReportSix",
        name: "ReportSix",
        meta: {
          cache: true
        },
        component: _import("Report/RerportSix"),
      },
      {
        path: "ReportSeven",
        name: "ReportSeven",
        meta: {
          cache: true
        },
        component: _import("Report/ReportSeven"),
      },
      {
        path: "ReportEight",
        name: "ReportEight",
        meta: {
          cache: true
        },
        component: _import("Report/ReportEight"),
      },
      {
        path: "ReportNine",
        name: "ReportNine",
        meta: {
          cache: true
        },
        component: _import("Report/ReportNine"),
      },
      {
        path: "ReportTen",
        name: "ReportTen",
        meta: {
          cache: true
        },
        component: _import("Report/ReportTen"),
      },
      {
        path: "ReportEleven",
        name: "ReportEleven",
        meta: {
          cache: true
        },
        component: _import("Report/ReportEleven"),
      },
      {
        path: "ReportTwenty",
        name: "ReportTwenty",
        component: _import("Report/ReportTwenty"),
        meta: {
          cache: true,
        },
      },
      // 竞品与摆品V2版本
      {
        path: "ReportTwentyV2",
        name: "ReportTwentyV2",
        component: _import("Report/ReportTwentyV2"),
        meta: {
          pass:true,
          cache: true,
        },
      },
      {
        path: "qsInventory",
        name: "qsInventory",
        component: _import("Report/qsInventory"),
        meta:{
          cache: true
        }
      },
      {
        path: "qsReport",
        name: "qsReport",
        component: _import("Report/qsReport"),
        meta:{
          cache: true
        }
      },
      {
        path: "ReportTwentyDetail",
        name: "ReportTwentyDetail",
        meta: {
          hidden: true,
        },
        component: _import("Report/components/reportTwentyDetail"),
      },

      {
        path: "newPrices",
        name: "newPrices",
        meta: {
          cache: true
        },
        component: _import("relatingPrices/newPrices"),
      },
      {
        path: "quotationSheet",
        name: "quotationSheet",
        meta: {
          cache: true
        },
        component: _import("relatingPrices/quotationSheet"),
      },
      // 出差
      {
        path: "Travel",
        name: "Travel",
        component: _import("Travel/Travel"),
      },
      {
        path: "addTravel",
        name: "addTravel",
        meta: {
          hidden: true,
        },
        component: _import("Travel/components/addTravel"),
      },
      {
        path: "usCP",
        name: "usCP",
        component: _import("usCP/index"),
        meta: {
          cache: true
        }
      },
        // newcp
      {
        path: "newCP",
        name: "newCP",
        component: _import("newCP/index"),
        meta: {
          cache: true
        }
      },
      // mainCPAarea (新路由)
      {
        path: "mainCPAarea",
        name: "mainCPAarea",
        component: _import("newCP/mainCPAarea.vue"),
        meta: {
          cache: true,
          hidden: true
        }
      },
      // mainUSAarea (新路由)
      {
        path: "mainUSarea",
        name: "mainUSarea",
        component: _import("usCP/mainCPAarea.vue"),
        meta: {
          cache: true,
          hidden: true
        }
      },
      // 竞品
      {
        path: "competitors",
        name: "competitors",
        component: _import("competitors/competitors"),
        meta: {
          cache: true
        }
      },
      {
        path: "addCompetitors",
        name: "addCompetitors",
        meta: {
        },
        component: _import("competitors/addCompetitors"),
      },
      // 商品
      {
        path: "competingGoods",
        name: "competingGoods",
        component: _import("competingGoods/competingGoods"),
        meta: {
          cache: true
        }
      },
      {
        path: "competingGoodsInfo",
        name: "competingGoodsInfo",
        meta: {
          cache: true
        },
        component: _import("competingGoods/competingGoodsInfo"),
      },
      {
        path: "addCompetingGoods",
        name: "addCompetingGoods",
        meta: {
          hidden: true,
        },
        component: _import("competingGoods/addCompetingGoods"),
      },
      {
        path: "editCompetingGoods",
        name: "editCompetingGoods",
        meta: {
        },
        component: _import("competingGoods/editCompetingGoods"),
      },

      {
        path: "exhibition",
        name: "exhibition",
        component: _import("Commitments/Commitments"),
        meta:{
          cache: true
        }
      },
      {
        path: "Commitments",
        name: "Commitments",
        component: _import("Commitments/Commitments"),
        meta: {
          cache: true
        },
      },
      {
        path: "tableList",
        name: "tableList",
        meta: {
          cache: true

        },
        component: _import("Commitments/tableList"),
      },
      {
        path: "intentionTab",
        name: "intentionTab",
        meta: {
          hidden: true,
          cache: true
        },
        component: _import("Commitments/intentionTab"),
      },
      {
        path: "TotalCommitments",
        name: "TotalCommitments",
        meta: {
          cache: true

        },
        component: _import("Commitments/TotalCommitments"),
      },
      {
        path: "addCommitments",
        name: "addCommitments",
        meta: {
          hidden: true,
        },
        component: _import("Commitments/addCommitments"),
      },

      // 视频和图片
      {
        path: "lmageVideo",
        name: "lmageVideo",
        component: _import("Video/Video"),
        meta: {
          cache: true
        }
      },
      {
        path: "addVideo",
        name: "addVideo",
        meta: {
          hidden: true,
        },
        component: _import("Video/addVideo"),
      },
      {
        path: "addCover",
        name: "addCover",
        meta: {
        },
        component: _import("Video/addCover"),
      },
      // 视频和图片
      {
        path: "Cover",
        name: "Cover",
        meta: {
          cache: true
        },
        component: _import("Video/Cover"),
      },
      {
        path: "dayawanCover",
        name: "dayawanCover",
        meta: {
          cache: true
        },
        component: _import("Video/dayawanCover"),
      },
      {
        path: "vietnamCover",
        name: "vietnamCover",
        meta: {
          cache: true
        },
        component: _import("Video/vietnamCover"),
      },
      {
        path: "productInfo",
        name: "productInfo",
        meta: {
          cache: true
        },
        component: _import("Product/productInfo"),
      },
      {
        path: "rankInfo",
        name: "rankInfo",
        meta: {
          cache: true
        },
        component: _import("Product/rankInfo"),
      },
      //颜色特征
      {
        path: "CoverFeature",
        name: "CoverFeature",
        component: _import("Video/CoverFeature"),
        meta: {
          cache: true
        }
      },
      // 知识库
      {
        path: "Catalog",
        name: "Catalog",
        component: _import("Documents/Documents"),
        meta: {
          cache: true
        }
      },
      {
        path: "addDocuments",
        name: "addDocuments",
        meta: {
          hidden: true,
        },
        component: _import("Documents/addDocuments"),
      },

      // 业绩
      {
        path: "Performance",
        name: "Performance",
        component: _import("Performance/Performance"),
        meta: {
          cache: true
        }
      },
      {
        path: "Performance2",
        name: "Performance2",
        component: _import("Performance/Performance2"),
        meta: {
          cache: true
        }
      },
      {
        path: "Performance3",
        name: "Performance3",
        meta: {
          cache:true
        },
        component: _import("Performance/Performance3"),
      },
      {
        path: "addPerformance",
        name: "addPerformance",
        meta: {
          hidden: true,
        },
        component: _import("Performance/addPerformance"),
      },
      {
        path: "arms",
        name: "Arms",
        meta: {
          cache:true,
        },
        component: _import("Admin/arms"),
      },
      {
        path: "loginlog",
        name: "loginlog",
        component: _import("Admin/loginlog"),
        meta:{
          pass:true,
          cache: true
        }
      },
      {
        path: "backs",
        name: "Backs",
        meta: {
          cache:true,
        },
        component: _import("Admin/backs"),
      },
      {
        path: "rai",
        name: "rai",
        meta: {
          cache:true,
        },
        component: _import("Admin/resignationAndInheritance"),
      },
      {
        path: "CreatedAccount",
        name: "createdAccount",
        meta: {
          cache:true,
        },
        component: _import("Admin/CreatedAccount"),
      },
      {
        path: "categories",
        name: "Categories",
        meta: {
          cache:true,
        },
        component: _import("Admin/categories"),
      },
      {
        path: "features",
        name: "Features",
        meta: {
          cache:true,
        },
        component: _import("Admin/features"),
      },
      {
        path: "mwhCompetitorFeatures",
        name: "mwhCompetitorFeatures",
        meta: {
          cache:true,
        },
        component: _import("competitiveProductAnalysis/feature/features.vue"),
      },
      {
        path: "mechanisms",
        name: "Mechanisms",
        meta: {
          cache:true,
        },
        component: _import("Admin/mechanisms"),
      },
      {
        path: "seats",
        name: "Seats",
        meta: {
          cache:true,
        },
        component: _import("Admin/seats"),
      },
      {
        path: "sku",
        name: "SKU",
        meta: {
          cache:true,
        },
        component: _import("Admin/sku"),
      },
      {
        path: "styles",
        name: "Styles",
        meta: {
          cache:true,
        },
        component: _import("Admin/styles"),
      },
      {
        path: "arrangements",
        name: "Arrangements",
        meta: {
          cache: true

        },
        component: _import("Admin/arrangements"),
      },
      {
        path: "covers",
        name: "Covers",
        meta: {
          cache: true

        },
        component: _import("Admin/covers"),
      },
      {
        path: "coversGrades",
        name: "CoversGrades",
        meta: {
          cache: true

        },
        component: _import("Admin/coversGrades"),
      },
      {
        path: "coversGroups",
        name: "CoversGroups",
        meta: {
          cache: true

        },
        component: _import("Admin/coversGroups"),
      },
      {
        path: "models",
        name: "Models",
        meta: {
          cache: true
        },
        component: _import("Admin/models"),
      },
      {
        path: "modelsDetail",
        name: "modelsDetail",
        meta: {
          hidden: true,
        },
        component: _import("Admin/modelsDetail"),
      },
      {
        path: "cart", //选购清单
        name: "cart",
        meta: {
          cache: true
        },
        component: _import("Admin/cart"),
      },
      {
        path: "poList", //PO清单
        name: "poList",
        meta: {
          cache: true
        },
        component: _import("Admin/poList"),
      },
      {
        path: "price",
        name: "Price",
        meta: {
          cache: true
        },
        component: _import("Admin/price"),
      },

      // 其他
      {
        path: "DFSEDIInvolce",
        name: "DFSEDIInvolce",
        component: _import("others/DFSEDIInvolce"),
        meta: {
        }
      },

      //重置密码
      {
        path: "resetPassword",
        name: "resetPassword",
        component: _import("system/resetPwd/index"),
      },

      // 系统 前端日志
      {
        path: "log",
        name: "log",
        meta: {
          title: "前端日志",
        },
        component: _import("system/log"),
      },

      // 刷新页面 必须保留
      {
        path: "refresh",
        name: "refresh",
        meta: {
        },
        component: _import("system/function/refresh"),
      },

      // 页面重定向 必须保留
      {
        path: "redirect/:route*",
        name: "redirect",
        meta: {
        },
        component: _import("system/function/redirect"),
      },

      // 库存共享-产品信息配置
      {
        path: "InventoryPlatformProductInfoConfig",
        name: "InventoryPlatformProductInfoConfig",
        component: _import("InventoryPlatform/ProductInfoConfig"),
        meta: {
          cache: true
        }
      },
      // 库存共享-客户数据
      {
        path: "InventoryPlatformCustomerData",
        name: "InventoryPlatformCustomerData",
        component: _import("InventoryPlatform/CustomerData"),
        meta: {
        }
      },
      // 库存共享-客户数据
      {
        path: "InventoryPlatformCustomerDataNew",
        name: "InventoryPlatformCustomerDataNew",
        component: _import("InventoryPlatform/CustomerData"),
        meta: {
          cache: true
        }
      },
      // 库存共享-库存共享报表
      {
        path: "InventoryPlatformSharingReport",
        name: "InventoryPlatformSharingReport",
        component: _import("InventoryPlatform/SharingReport"),
        meta: {
          cache: true
        }
      },
      // 新款维护
      {
        path: "NewStyleMaintenance",
        name: "NewStyleMaintenance",
        component: _import("Admin/NewStyleMaintenance/index"),

      },
      //展会奖金分配
      {
        path: "ExhibitionBonusDistribution",
        name: "ExhibitionBonusDistribution",
        component: _import("Admin/ExhibitionBonusDistribution/index"),
        meta: {
          cache: true
        }
      },
      //展会奖金款式
      {
        path: "ExhibitionBonusStyles",
        name: "ExhibitionBonusStyles",
        component: _import("Admin/ExhibitionBonusStyles/index"),
        meta: {
          cache: true
        }
      },
      // 规格关系
      {
        path: "SpecificationRelationship",
        name: "SpecificationRelationship",
        component: _import("Admin/SpecificationRelationship/index"),
        meta: {
          cache: true
        }
      },
      // 跟进情况表
      {
        path: "FollowUpSituationTable",
        name: "FollowUpSituationTable",
        component: _import("Commitments/FollowUpSituationTable/index"),
        meta: {
          cache: true
        }
      },
      // 确认订单明细
      {
        path: "ConfirmOrderDetails",
        name: "ConfirmOrderDetails",
        meta: {
          cache: true
        },
        component: _import("Commitments/ConfirmOrderDetails/index"),
      },
      // 展会奖金报表
      {
        path: "MarketNewModelBonusReport",
        name: "MarketNewModelBonusReport",
        component: _import("Commitments/MarketNewModelBonusReport/index"),
        meta: {
          cache: true
        }
      },
      // 展会Tabs
      {
        path: "ExReservationTabs",
        name: "ExReservationTabs",
        component: _import("Commitments/ExReservation/ExReservationTabs"),
        meta: {
          cache: true
        }
      },
      // 展会审批Tabs
      {
        path: "ExReservationApprovalTabs",
        name: "ExReservationApprovalTabs",
        component: _import("Commitments/ExReservation/ExReservationApprovalTabs"),
        meta: {
          hidden: true,
          cache: true
        }
      },
      // 展会
      {
        path: "ExReservation",
        name: "ExReservation",
        component: _import("Commitments/ExReservation/index"),
        meta: {
          // hidden: true,
          cache: true
        }
      },
      {
        path: "ExReservationInvitationSummary",
        name: "ExReservationInvitationSummary",
        component: _import("Commitments/ExReservation/invitationSummaryForDivision"),
        meta: {
          cache: true,
        }
      },
      {
        path: "ExReservationInvitationSummaryForBusiness",
        name: "ExReservationInvitationSummaryForBusiness",
        component: _import("Commitments/ExReservation/invitationSummaryForBusiness"),
        meta: {
          cache: true
        }
      },
      // 意向清单
      {
        path: "tableListbyCustomer",
        name: "tableListbyCustomer",
        component: _import("Commitments/tableListbyCustomer"),
        meta: {
          // hidden: true,
          cache: true
        }
      },
      // 竞品分析
      {
        path: "CompetitiveProductAnalysis",
        name: "CompetitiveProductAnalysis",
        component: _import("competitiveProductAnalysis/index"),
        meta: {
          pass:true,
          cache: true
        }
      },
      // 竞品分析数据列表
      {
        path: "CompetitiveProductAnalysisDataList",
        name: "CompetitiveProductAnalysisDataList",
        component: _import("competitiveProductAnalysis/dataList"),
        meta:{
          pass:true,
          cache: true
        }
      },
      {
        path: "vpsalesMezzanine",
        name: "vpsalesMezzanine",
        component: _import("competitiveProductAnalysis/vpsalesMezzanine.vue"),
        meta:{
          pass:true,
          cache: true
        }
      },

      // 必选跳转
      // {
      //   path: "CompetitiveProductAnalysisCheckItem",
      //   name: "CompetitiveProductAnalysisCheckItem",
      //   component: _import("competitiveProductAnalysis/checkItem"),
      //   meta:{
      //     cache: true
      //   }
      // },
      // 竞品分析款式
      {
        path: "CompetitiveProductAnalysisStyles",
        name: "CompetitiveProductAnalysisStyles",
        component: _import("competitiveProductAnalysis/styles"),
        meta: {
          hidden: true
        }
      },
      // 竞品分析款式-编辑/保存
      {
        path: "CompetitiveProductAnalysisSave",
        name: "CompetitiveProductAnalysisSave",
        component: _import("competitiveProductAnalysis/save"),
        meta: {
          hidden: true
        }
      },
      // 竞品分析款式-预览
      {
        path: "CompetitiveProductAnalysisPreview",
        name: "CompetitiveProductAnalysisPreview",
        component: _import("competitiveProductAnalysis/preview.vue"),
        meta: {
          hidden: true
        }
      },
      // 接单情况
      {
        path: "OrderIntake",
        name: "OrderIntake",
        component: _import("OrderIntake/index"),
        meta: {
          cache: true
        }
      },
      // 接单情况详情
      {
        path: "OrderIntakeDetail",
        name: "OrderIntakeDetail",
        component: _import("OrderIntake/detail"),
        meta: {
          hidden: true,
          cache: true
        }
      },
      // 接单情况子详情
      {
        path: "OrderIntakeSubDetail",
        name: "OrderIntakeSubDetail",
        component: _import("OrderIntake/subDetail"),
        meta: {
          hidden: true,
          cache:true
        }
      },
      // 美国事业部2024年03主推款式销量排行榜-皮款-321 高档
      {
        path: "MainPushStyleSalesRanking",
        name: "MainPushStyleSalesRanking",
        component: _import("MainPushStyleSalesRanking"),
        meta: {
          cache: true
        }
      },
      {
        path: "MainPushStyleSalesRankingTwo",
        name: "MainPushStyleSalesRankingTwo",
        component: _import("MainPushStyleSalesRankingTwo"),
        meta: {
          cache: true
        }
      },
      // 装柜尺寸
      {
        path: "ContainerDimensions",
        name: "ContainerDimensions",
        component: _import("Admin/containerDimensions"),
        meta: {
          cache: true
        }
      },
      {
        path: "AccountHierarchySettings",
        name: "AccountHierarchySettings",
        meta: {
          cache: true
        },
        component: _import("Admin/accountHierarchySettings"),
      },
      // 待办提醒
      {
        path: "ToDoReminder",
        name: "ToDoReminder",
        component: _import("ToDoReminder"),
        meta: {
        }
      },
      // 产品展示
      // {
      //   path: "ProductDisplay",
      //   name: "ProductDisplay",
      //   component: _import("ProductDisplay"),
      //   meta: {
      //     cache: true
      //   }
      // }
    ],
  },
];

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: "/login",
    name: "login",
    meta: {
      hidden: true,
      pass: true,
    },
    component: _import("system/login"),
  },
];

/**
 * 错误页面
 */
const errorPage = [
  {
    path: "*",
    name: "404",
    meta: {
      hidden: true,
      pass: true,
    },
    component: _import("system/error/404"),
  },
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage];
